module.exports = __webpack_public_path__ + "static/media/h4.649b9b31.jpg";